/* Subtle Goods — theme.js */
(function () {
  'use strict';

  /* ---------- Toast ---------- */
  var toast = document.getElementById('toast');
  var toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* ---------- Mobile nav ---------- */
  var drawer = document.getElementById('nav-drawer');
  var navOpen = document.getElementById('nav-open');
  if (drawer && navOpen) {
    function openNav() { drawer.hidden = false; navOpen.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; }
    function closeNav() { drawer.hidden = true; navOpen.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; }
    navOpen.addEventListener('click', openNav);
    drawer.querySelectorAll('[data-nav-close]').forEach(function (el) { el.addEventListener('click', closeNav); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeNav(); });
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = n;
    if (n > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', '');
  }

  /* ---------- Product form ---------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variants = [];
    try { variants = JSON.parse(document.querySelector('[data-variants]').textContent); } catch (e) {}
    var stockMap = {};
    try { stockMap = JSON.parse(document.querySelector('[data-stock-map]').textContent); } catch (e) {}
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.getElementById('pdp-price');
    var stockEl = form.querySelector('[data-stock]');
    var atc = form.querySelector('[data-atc]');
    var atcText = form.querySelector('[data-atc-text]');
    var optionCount = form.querySelectorAll('fieldset.opt').length;

    function money(cents) {
      var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function selected() {
      var vals = [];
      for (var i = 0; i < optionCount; i++) {
        var r = form.querySelector('input[name="opt-' + i + '"]:checked');
        vals.push(r ? r.value : null);
      }
      return vals;
    }

    function findVariant(vals) {
      return variants.find(function (v) {
        return vals.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var v = findVariant(selected());
      if (!v) {
        atc.disabled = true; atcText.textContent = 'Unavailable'; stockEl.textContent = ''; return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.available) {
        atc.disabled = false; atcText.textContent = 'Add to cart';
        var q = stockMap[v.id];
        if (v.inventory_management && typeof q === 'number' && q > 0 && q <= 3) stockEl.textContent = 'Only ' + q + ' left';
        else stockEl.textContent = '';
      } else {
        atc.disabled = true; atcText.textContent = 'Sold out'; stockEl.textContent = '';
      }
      // keep URL in sync for sharing
      if (history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      }
    }

    form.addEventListener('change', function (e) { if (e.target.matches('input[type=radio]')) update(); });
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.disabled = true; atcText.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || 'Could not add to cart');
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          showToast('Added to cart <a href="/cart">View cart</a>');
          atcText.textContent = 'Added';
          setTimeout(update, 1200);
        })
        .catch(function (err) {
          showToast(err.message);
          update();
        });
    });
  }

  /* ---------- Klaviyo SMS signup ---------- */
  var smsForm = document.querySelector('[data-sms-form]');
  if (smsForm) {
    var smsInput = smsForm.querySelector('input[type=tel]');
    var smsBtn = smsForm.querySelector('button');
    var smsMsg = smsForm.querySelector('[data-sms-msg]');
    function smsSay(text, state) { smsMsg.textContent = text; smsMsg.setAttribute('data-state', state || ''); }
    function toE164(v) {
      var s = String(v).trim();
      var digits = s.replace(/\D/g, '');
      if (s.charAt(0) === '+') return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      return null;
    }
    smsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var phone = toE164(smsInput.value);
      if (!phone) { smsSay('Enter a valid mobile number.', 'error'); smsInput.focus(); return; }
      smsBtn.disabled = true; smsSay('');
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(smsForm.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-01-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: smsForm.dataset.source,
            profile: { data: { type: 'profile', attributes: {
              phone_number: phone,
              subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: smsForm.dataset.list } } }
        } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        smsForm.querySelector('.signup__row').hidden = true;
        smsSay("Check your phone — reply YES to confirm and your free-shipping code will follow.", 'ok');
      }).catch(function () {
        smsBtn.disabled = false;
        smsSay('Something went wrong. Please try again.', 'error');
      });
    });
  }

  /* ---------- Cart page: auto-submit qty changes ---------- */
  var cartForm = document.querySelector('.cartpg__form');
  if (cartForm) {
    cartForm.querySelectorAll('.qty').forEach(function (input) {
      input.addEventListener('change', function () {
        var btn = cartForm.querySelector('button[name=update]');
        if (btn) btn.click();
      });
    });
  }
})();
